import { useNavigate } from "react-router-dom";
import { paths } from "../routes/paths";
import styles from "../styles/_components/totalCard.module.scss";

const TotalCard = ({ visitors, setVisitors }) => {
  const navigate = useNavigate();
  return (
    <div className={styles.container}>
      <div className={styles.right}>
        <div className={styles.row}>
          <h3>Item</h3>
          <h3>Price</h3>
        </div>
        <div className={styles.row}>
          <p className={styles.name}>
            Entrance fees to the Ben-Gurion barracks site
          </p>
          <p className={styles.price}>$50</p>
        </div>
        <div className={styles.row}>
          <p className={styles.name}>
            Entrance fees to the Ben-Gurion barracks site
          </p>
          <p className={styles.price}>$50</p>
        </div>
      </div>
      <div className={styles.left}>
        <p className={styles.totalPrice}>
          Total payment: <span>$100</span>
        </p>
        <button onClick={() => navigate(paths.orderDetails)}>
          Continue
          <img src="/assets/upIcon2.svg" alt="chevron" />
        </button>
      </div>
    </div>
  );
};

export default TotalCard;
